export default __webpack_public_path__ + "static/media/december.794a0d28.png";